function checkSelectMaintenance() {
  const maintenance = $(".maintenance-block").first();
  if (!maintenance) {
    return true;
  }
  const originType = maintenance.attr("data-origin-product-type");
  const form = document.getElementById("maintenance_form");
  const submitFormId = form.dataset.productFormId;
  const formData = new FormData(form);

  const quantity = formData.get("attribute[quantity]");
  const cautionAgree = getCautionAgree();
  const maintenanceSelect = getMaintenanceSelect();

  if (maintenanceSelect === null) {
    $("#maintenance-caution-wrapper").slideUp();
  } else if (maintenanceSelect === "1") {
    $("#maintenance-caution-wrapper").slideUp();
    setButtonSubmitData(originType);
  } else {
    $("#maintenance-caution-wrapper").slideDown();
    setButtonSubmitData(CART_STATUS.NORMAL);
  }

  if ((maintenanceSelect && cautionAgree) || maintenanceSelect === "1") {
    $(`#${submitFormId}`)
      .find('input[name="properties[Installation Quantity]"]')
      .remove();
    if (maintenanceSelect === "1" && quantity > 0) {
      $(
        `<input type="hidden" name="properties[Installation Quantity]" value="${quantity}">`,
      ).appendTo(`#${submitFormId}`);
    }
    return true;
  }
  return false;
}

function getMaintenanceSelect() {
  const form = document.getElementById("maintenance_form");
  const formData = new FormData(form);
  return formData.get("attribute[maintenance]");
}

function getCautionAgree() {
  const form = document.getElementById("maintenance_form");
  const formData = new FormData(form);
  return formData.get("attribute[caution]");
}

function setButtonSubmitData(maintenance) {
  const forms = document.querySelectorAll("product-form form");
  if (forms.length) {
    const buttons = forms[0].querySelectorAll('button[type="submit"]');
    buttons.forEach((button) => (button.dataset.maintenance = maintenance));
  }
}

function setButtonDisable(status) {
  // check if button exists and not Sold Out (has class is_sold_out)
  const button = $("product-form").find("form").first().find("button");
  if (button.length && !button.hasClass("is_sold_out")) {
    button.prop("disabled", status);
  }
  // $("product-form")
  //   .find("form")
  //   .first()
  //   .find("button")
  //   .each(function () {
  //     $(this).prop("disabled", status);
  //   });
}

//DOM Ready using jquery
$(document).ready(function () {
  // get #product_handle value, if exist and equal 345 then set button disable false
  const productHandle = $("#product_handle").val();
  if (productHandle === "345") {
    setButtonDisable(false);
    checkSelectMaintenance();
    // on change then check
    $(".maintenance_input").on("change", function () {
      checkSelectMaintenance();
    });

    // event when form action /cart/add is submit
    $(".product-form").on("submit", "form", function (e) {
      $(this).find('button[type="submit"]').addClass("disabled");
      $(this).find('button[type="submit"]').prop("disabled", true);
      $(this).find('button[type="submit"]').html("カートに追加しました");
    });
  } else {
    // the first time check
    if (checkSelectMaintenance()) {
      setButtonDisable(false);
    } else {
      setButtonDisable(true);
    }

    // on change then check
    $(".maintenance_input").on("change", function () {
      if (checkSelectMaintenance()) {
        setButtonDisable(false);
      } else {
        setButtonDisable(true);
      }
    });
  }
});
